import React from "react";
import { Sun, Moon, Cloud, Snowflake, Flower, Leaf, Flame } from "lucide-react";
import { useGame } from "@/contexts/GameContext";
import { getStoredLang } from "@/utils/i18n";

const SEASON_ICON = {
  spring: Flower,
  summer: Sun,
  autumn: Leaf,
  winter: Snowflake,
};

const TOD_ICON = {
  morning: Sun,
  afternoon: Sun,
  evening: Cloud,
  night: Moon,
};

const SEASON_IT = { spring: "Primavera", summer: "Estate", autumn: "Autunno", winter: "Inverno" };
const TOD_IT = { morning: "Mattina", afternoon: "Pomeriggio", evening: "Sera", night: "Notte" };

/**
 * WorldClockBadge — tiny read-only widget (iter 72).
 *
 * Renders the in-game clock so the player sees day/season/weather ticking
 * alongside their story. No click handlers — purely ambient context.
 */
export default function WorldClockBadge() {
  const { game } = useGame();
  const clock = game?.world_clock;
  if (!clock) return null;

  const lang = getStoredLang();
  const isIt = lang === "it";

  const SeasonIcon = SEASON_ICON[clock.season] || Flower;
  const TodIcon = TOD_ICON[clock.time_of_day] || Sun;

  const seasonLabel = isIt ? (SEASON_IT[clock.season] || clock.season) : clock.season;
  const todLabel = isIt ? (TOD_IT[clock.time_of_day] || clock.time_of_day) : clock.time_of_day;

  return (
    <div
      data-testid="world-clock-badge"
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#0a0a0c]/60 border border-[#cfb53b]/20 text-[10px] text-[#cfb53b] font-heading"
      title={clock.weather || ""}
    >
      <span className="flex items-center gap-0.5">
        <Flame size={10} className="text-[#cfb53b]/70" />
        {isIt ? "G." : "D."} {clock.day}
      </span>
      <span className="text-[#cfb53b]/30">·</span>
      <span className="flex items-center gap-0.5">
        <SeasonIcon size={10} className="text-[#cfb53b]/70" />
        {seasonLabel}
      </span>
      <span className="text-[#cfb53b]/30">·</span>
      <span className="flex items-center gap-0.5">
        <TodIcon size={10} className="text-[#cfb53b]/70" />
        {todLabel}
      </span>
    </div>
  );
}
